<template>
    <div>
        <v-card>
            <template v-if="showFilter">
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-col cols="12" md="4">
                        <input-auto-complete :setup.sync="selects.client"></input-auto-complete>
                    </v-col>
                    <v-divider
                        class="mx-3 hidden-md-and-down mt-0"
                        inset
                        vertical
                    ></v-divider>
                    <v-btn
                        :loading="loading"
                        :disabled="loading"
                        class="ml-1"
                        color="purple"
                        :dark="!loading"
                        @click.prevent="loadData()"
                    >
                        {{ $t('common.update') }}
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
            </template>
            <v-tabs
                ref="tabs"
                v-model="activeTab"
                vertical
            >
                <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" @change="setTabActive(tab.id)" exact class="justify-start">
                    <v-icon left>{{ tab.icon}}</v-icon>
                    {{ tab.name }}
                </v-tab>

                <v-tabs-items v-model="activeTab">
                    <router-view></router-view>
                </v-tabs-items>
            </v-tabs>
        </v-card>
    </div>
</template>

<script>
import InputAutoComplete from '@/components/InputAutoComplete'

export default {
    name: 'corporate',
    metaInfo () {
        return {
            title: this.$t('corporate.meta.title'),
            meta: [
                { name: 'description', content: this.$t('corporate.meta.description') },
                { name: 'keywords', content: this.$t('corporate.meta.keywords') }
            ]
        }
    },
    components: {
        InputAutoComplete
    },
    data () {
        return {
            showFilter: false,
            loading: false,
            name: '',
            activeTabId: 1,
            activeTab: `/societario/captable`,
            tabs: [
                { id: 1, icon: 'pie_charts', name: this.$t('corporate.tabs.captable'), route: `/societario/captable` },
                { id: 2, icon: 'group_work', name: this.$t('corporate.tabs.administration'), route: `/societario/administracao` },
                { id: 3, icon: 'history', name: this.$t('corporate.tabs.constitutiveActs'), route: `/societario/atos-constitutivos` }
            ],
            selects: {
                client: {
                    label: this.$t('corporate.client.label'),
                    text: 'name',
                    value: 'objectId',
                    icon: 'contacts',
                    multiple: false,
                    clearable: false,
                    hideDetails: true,
                    items: [],
                    selectedItems: []
                }
            },
            id: undefined
        }
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (val.name === 'Societario') {
                    this.$router.push(`/societario/captable`).catch(e => {})
                }
                if (oldVal !== val) {
                    this.activeTab = `/societario/captable`
                    this.tabs = [
                        { id: 1, icon: 'pie_charts', name: this.$t('corporate.tabs.captable'), route: `/societario/captable` },
                        { id: 2, icon: 'group_work', name: this.$t('corporate.tabs.administration'), route: `/societario/administracao` },
                        { id: 3, icon: 'history', name: this.$t('corporate.tabs.constitutiveActs'), route: `/societario/atos-constitutivos` }
                    ]
                    this.$refs.tabs.callSlider()
                }
            },
            deep: true
        },
        'selects.client.selectedItems': {
            handler: function (val) {
                this.$helpers.setCorporateClient(val)
            },
            deep: true
        }
    },
    mounted () {
        this.init()
        this.$router.push(`/societario/captable`).catch(e => {})
    },
    beforeDestroy () {
        this.$helpers.setCorporateClient(undefined)
    },
    methods: {
        async init () {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            if (currentUserCompany.client.type === 'manager') {
                await this.getAllClient()
                this.selects.client.selectedItems = currentUserCompany.client.objectId
                this.showFilter = true
            }
        },
        async getAllClient () {
            this.selects.client.items = await this.$helpers.getAllClient(null, false, true)
        },
        loadData () {
            window.dispatchEvent(new Event('storageChange'))
        },
        setTabActive (index) {
            this.activeTabId = index
        }
    }
}
</script>
